import Container from '@mui/material/Container';

interface FileViewerProps {
    fileInfo: {
        url: string;
        filename: string;
    };
    height: number;
    width?: number;
}

const FileViewer: React.FC<FileViewerProps> = ({ fileInfo: { url, filename }, height }) => {

    let viewer: any;
    try {
        if (filename.includes("pdf") || filename.includes("xlsx") || filename.includes("docx") || filename.includes("html")) {
            viewer =
                <div>
                    <embed
                        src={url}
                        width='90%'
                        height={Math.floor(height * 0.8)}></embed>
                </div>
        } else if (filename.includes("jpg")) {
            viewer =
                <div>
                    <p>{filename}</p>
                    <img
                        src={url}
                        width='90%'
                        alt="English score" />
                </div>

        } else {
            viewer =
                <div>
                    <p>{filename}</p>
                    <br />
                    <p>This file format is not supported.</p>
                    <br />
                    <p>Convert the file to PDF.</p>
                </div>
        }

    } catch (error) {
        viewer = <p>Something went wrong...</p>
        console.log(error);
    }
    return (
        <Container>
            {viewer}
        </Container>
    );
};

export default FileViewer
